import {
  AppstoreOutlined,
  FilterOutlined,
  SearchOutlined,
  UnorderedListOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Input,
  List,
  Radio,
  Space,
  Tooltip,
  DatePicker,
  Layout,
  Typography,
  Card,
} from "antd";
import Search from "antd/es/input/Search";
import { useState } from "react";
import type { Dayjs } from "dayjs";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

interface Props {
  onSearch: (value: string) => void;
  onSearchChangeValue?: (value: string) => void;
  onChangeViewLayout: (value: any) => void;
  onSearchPressEnter: (value: any) => void;
  onDateRangeSelect?: (value: any) => void;
  onOrganizerChangeValue?: (value: string) => void;
  onEventTypeValueChange?: (
    value: React.SetStateAction<"Presencial" | "Virtual" | "Mixto" | null>
  ) => void;
}

const SearchEventsForm = (props: Props) => {
  const [searchText, setSearchText] = useState("");
  const [organizerSearchText, setOrganizerSearchText] = useState("");
  const [isListView, setIsListView] = useState(true);
  const [eventType, setEventType] = useState<
    "Presencial" | "Virtual" | "Mixto" | null
  >(null);
  const [selectedDateRange, setSelectedDateRange] = useState<Dayjs[] | null>(
    null
  );
  const [organizer, setOrganizer] = useState("");

  return (
    <>
      <Space direction="vertical" size={24} className="w-full">
        <Row gutter={16} align="middle">
          <Col>
            <RangePicker
              size="large"
              onChange={(dates) => {
                if (props.onDateRangeSelect) {
                  props.onDateRangeSelect(dates);
                }
              }}
            />
          </Col>
          <Col flex="auto">
            <Input
              size="large"
              placeholder="Buscar por organizador"
              prefix={<UserSwitchOutlined className="text-gray-400" />}
              value={organizerSearchText}
              onChange={(e) => {
                if (props.onOrganizerChangeValue) {
                  props.onOrganizerChangeValue(e.target.value);
                  setOrganizerSearchText(e.target.value);
                }
              }}
            />
          </Col>
          <Col flex="auto">
            <Search
              addonBefore={<SearchOutlined />}
              className="ant-input-shadow"
              placeholder="Buscar por nombre de evento"
              allowClear
              onChange={(event) => {
                if (props.onSearchChangeValue) {
                  props.onSearchChangeValue(event.target.value);
                }
              }}
              onPressEnter={($event: any) => {
                props.onSearchPressEnter($event.target.value);
              }}
              onSearch={(value: string) => {
                props.onSearch(value);
              }}
              style={{ borderRadius: 0 }}
              enterButton="Buscar"
              size="large"
            />
          </Col>

          <Col>
            <Space>
              <Button
                icon={
                  isListView ? <AppstoreOutlined /> : <UnorderedListOutlined />
                }
                onClick={() => {
                  setIsListView(!isListView);
                  props.onChangeViewLayout(!isListView);
                }}
              >
                {isListView ? "Grilla" : "Lista"}
              </Button>
            </Space>
          </Col>
        </Row>
        <div className="flex items-center gap-4 flex-wrap">
          <Tooltip title="Filter by event type" style={{ marginRight: "16px" }}>
            <Button
              style={{ marginRight: "16px" }}
              icon={<FilterOutlined />}
              onClick={() => {
                setEventType(null);
                if (props.onEventTypeValueChange) {
                  props.onEventTypeValueChange(null);
                }
              }}
            >
              {eventType || "Todos"}
            </Button>
          </Tooltip>
          <Radio.Group
            value={eventType}
            onChange={(e) => {
              if (props.onEventTypeValueChange) {
                props.onEventTypeValueChange(e.target.value);
                setEventType(e.target.value);
              }
            }}
            style={{ marginRight: "16px" }}
          >
            <Radio.Button value="Presencial">Presencial</Radio.Button>
            <Radio.Button value="Virtual">Virtual</Radio.Button>
            <Radio.Button value="Mixto">Mixto</Radio.Button>
          </Radio.Group>
        </div>
      </Space>
    </>
  );
};

export default SearchEventsForm;
